// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
/** Tabs of one campaign. The `tab` search param picks the section; the default is the message (email editor). */
export const CAMPAIGN_TABS = ["email", "report"] as const;
export type CampaignTab = (typeof CAMPAIGN_TABS)[number];
